<template>
    <div class="upload-panel-wrapper col-md-5 p-0">
        <div class="close-or-min-panel">
            <div class="heading">{{$t('Scheduler')}}</div>
            <div class="close-icon-wrapper">
                <cancel-icon @click.native="closePanel" class="close-icon mt-1"></cancel-icon>
            </div>
        </div>
        <div class="info-wrapper">
            <div class="normal-text-display">
                <h6 class="comm-label"> {{$t('Name')}} :</h6>
                <span class="comm-value">{{$t('Name of the scheduled job')}}</span>
            </div>
            <div class="normal-text-display" style="margin-top: 15px;display:inline-block;width:100%">
                <h6 class="comm-label"> {{$t('Service')}} :</h6>
                <span class="comm-value">{{$t('Task which can be scheduled')}}.</span>
                <div class="normal-text-display" style="margin-inline-start:25px;">
                    <div class="sub-header-wrapper"><b class="sub-header">{{$t('There are two types of service')}}.</b></div>
                    <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">1</div></div><div class="text-for-bullet">{{$t('Inbuilt service')}} </div></div>
                    <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">2</div></div><div class="text-for-bullet">{{$t('External service provided by installed plugins')}} </div></div>
                </div>
            </div>  
            <div class="normal-text-display" style="margin-top: 15px;display:inline-block;width:100%">
                <h6 class="comm-label"> {{$t('Schedule')}} :</h6>
                <span class="comm-value">{{$t('Planned time to run selected service')}}.</span>  
                <div class="normal-text-display" style="margin-inline-start:25px;">
                <div class="sub-header-wrapper"><b class="sub-header">{{$t('Types of schedule')}}.</b></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">1</div></div><div class="text-for-bullet">{{$t('Every Day')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">2</div></div><div class="text-for-bullet">{{$t('Every Hour')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">3</div></div><div class="text-for-bullet">{{$t('Every Minute')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">4</div></div><div class="text-for-bullet">{{$t('Advanced')}}</div></div>
            </div> 
            </div>
                


            <div class="example-div">
                <!-- <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                    </svg>
                </div> -->
                <div>
                    <b><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                    </svg> {{$t('Example')}}:</b>
                    <div> 
                        <ul class="advanced-value-exapples-ul">
                            <li><b>0 12 * * ?</b><span> : </span><div>At 12:00 p.m. (noon) every day</div></li>
                            <li><b>0/5 13,18 * * ?</b> <span> : </span> <div> Every five minutes starting at 1 p.m. and ending at 1:55 p.m. and then starting at 6:00 p.m. and ending at 6:55 p.m., every day</div></li>
                            <li><b>0-5 13 * * ?</b><span> : </span><div>Every minute starting at 1:00 p.m. and ending at 1:05 p.m., every day</div></li>
                            <li><b>15,45 13 ? 6 Tue</b><span> : </span><div> At 1:15 p.m. and 1:45 p.m. every Tuesday in the month of June</div> </li>
                            <!-- <li><b>0 22 * * 1-5</b> : <span>At 14:15 on day-of-month 1</span></li>
                            <li><b>23 0-20/2 * * *</b> : <span>At minute 23 past every 2nd hour from 0 through 20</span></li>
                            <li><b>5 4 * * sun</b> : <span>At 04:05 on Sunday</span> </li>
                            <li><b>0 0,12 1 */2 *</b> : <span>At minute 0 past hour 0 and 12 on day-of-month 1 in every 2nd month</span></li>     -->
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="normal-text-display">While defining screen user can select required filed in specific screen, also in screen one can arrange order of the fields.</div>
            <div class="normal-text-display">User can specify fields behavior in the screen by selecting flags such as “Read only“, “MANDATORY” and “Display Always“.</div>
            <div class="normal-text-display"><b class="bold-text">Read Only:</b> When field set as read only flag, user can make specific fields as non editable by users, This flag is used for Fields like “Image Width“, which will be extracted from file information.</div>
            <div class="normal-text-display"><b class="bold-text">Mandatory:</b> When field made as Mandatory, then user required to fill this filed before proceeding further.</div> -->
            <div class="note-div">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-journal-text" viewBox="0 0 16 16">
                        <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                        <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/>
                        <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>
                    </svg>
                </div>
                <div>
                    <b style="color: #85ce9f;">Note:</b>
                    <ul class="advanced-value-note-ul">    
                        <li> <b>*</b> any value</li>
                        <li> <b>,</b> value list separator </li>
                        <li> <b>- </b>	range of values</li>
                        <li> <b>/</b>	step values</li>
                        
                    </ul>  
                </div>
            </div>
            <!-- <div class="normal-text-display"><b class="bold-text">Display Always:</b> When field set as display always, then this filed will be be displayed in screen irrespective of screen profiles.</div> -->
        </div>
    </div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue"
export default {
    components:{
        'cancel-icon':cancelIcon,
    },
    methods:{
        closePanel(){
            this.$emit("close");
        },
    },
}
</script>

<style scoped lang="scss">
    $header-background: #1a1a1a;
    $border-color: 1px solid #3a3a3a;
    $background: #121212;
    $background-color-on-hover: #141414;
    $body-background-color: #0d0d0d;
    $dull-text-color: #858585;
    $options-text-color: #9c9c9c;
    $icon-color-on-hover: #9c9c9c;
    $text-color: #eee;
    $table-row-border: none;
    $table-border-color:1px solid #141414;
    $active-blue: #007bff;
    $danger-color: #dc3545 !important;
    $input-field-bg-color: #121212;
    $input-field-border-color: #202020;
    $input-field-height:38px;
    $button-height:38px;
    $secondary-border-color: 1px solid #3a3a3a;
    $searchBar-border-color: 1px solid #202020;
    $secondary-text-color: #bbb;
    $modal-border:1px solid #202020;
    $modal-background: #121212;
    $header-color:#9e9e9e;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#141414;
    $scrollbar-thumb-on-hover-background:#555;
    $input-field-padding:.375rem 10px;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $breadcrumb-background:#161616;
    $mutliselect-tag-bg-color:#0a0a0a;
    $mutliselect-all-tags-bg-color:#161616;
    $multiselect-option-highlight-bg-color:#242424;
    $multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
    $overlay-info-panel-bg-color:#1b1b1b;
    $overlay-panel-border-color:#272727;
    $panel-heading-font-size:24px;
    $info-color:rgb(209, 210, 211);
    $info-font-size:15px;
    $info-sub-header-color:#e8912d;
    $info-header-font-size:22px;
    $tip-border-color:#23485f;
    $tip-background-color:#10202a;
    $tip-text-color:#8aa1ad;
    $tip-icon-color:#85b5ce;
    $bullet-background-color:#295318;
    $bold-text-color:#45b0ca;
    $example-background-color:#1b1b1b;
    $close-icon-bg-on-hover:#3a3a3a;
    $note-border-color:#1f4d27;
    $note-background-color:#0e28197a;
    $note-text-color:#6eab84;
    $note-icon-color:#85ce9f;


    .active{
        color:$active-blue;
    }

    .filters-bar{
        max-height: 100%;
        width: 100%;
        overflow:auto;
        display:inline-block;
        ul{
            list-style-type: none;
            padding-inline-start:2px;
            li{
                text-align: start;
                margin-inline-start: 6%;
                margin-top: 9px;
            }
        }
    }
    .upload-panel-wrapper{
        border-inline-start: 1px solid $overlay-panel-border-color;
        position: absolute;
        background: $background-color-on-hover;
        bottom: 1px!important;
        top: 0px !important;
        inset-inline-end: 0%;
        z-index: 9;
        max-height: 100%;
        height: 100%;
        box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
        -webkit-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
        -moz-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
        .close-or-min-panel{
                height: 60px;
                width:100%;
                border-bottom: 1px solid $overlay-panel-border-color;
                background: $overlay-info-panel-bg-color;
                text-align: end;
                padding: 12px;
                display: flex;
                justify-content: flex-end;
            }
        .info-wrapper{
                width: 100%;
                padding: 24px;
                overflow:auto;
                display:inline-block;
                height: 90%;
                .edit-upload-info{
                    width:8%;
                    padding: 5px;
                        svg{
                            position: relative;
                            inset-inline-end: 6px;
                        }
                }
                }
            }



    .edit-upload-info{
        position: relative;
        inset-inline-start:0px;
    }

    .minHeight{
        height:52px !important;
        bottom:1px !important;
        top: unset !important;
    }

    .upload-bars{
        margin-bottom: 12px;
    }

    .heading{
        text-align:start;
        width:94%;
        padding:2px;
        font-size:$panel-heading-font-size;
    }

    .normal-text-display{
        text-align: start;
        margin-bottom: 10px;
        color:$info-color;
        font-size:$info-font-size;
    }

    .comm-label{
        float:inline-start;
        // width:80px;
        text-align:end;
    }

    .comm-value{
        margin-inline-start:10px;
        text-align:start;
    }

    .sub-header{
        color: $info-sub-header-color;
        font-weight: 100;
        font-size:$info-header-font-size
    }

    .sub-header-wrapper{
        margin:5px 0px 5px 0px;
    }

    .tip-div{
        width: 100%;
        height: auto;
        display:inline-flex;
        padding: 12px;
        text-align: start;
        border: 1px solid $tip-border-color;
        background: $tip-background-color;
        border-radius: 5px;
        margin: 0px 0 20px 0;
        color: $tip-text-color;
        svg{
            margin: 0px 14px 0px 0px;
            color: $tip-icon-color;
        }
    }

    .note-div{
        width: 100%;
        height: auto;
        display:inline-flex;
        padding: 12px;
        text-align: start;
        border: 1px solid $note-border-color;
        background: $note-background-color;
        border-radius: 5px;
        margin: 0px 0 20px 0;
        color: $note-text-color;
        svg{
            margin: 0px 14px 0px 0px;
            color: $note-icon-color;
        }
    }


    .example-div{
        width: 100%;
        height: auto;
        display:inline-flex;
        padding: 12px;
        text-align: start;
        border: $border-color;
        background: $example-background-color;
        border-radius: 5px;
        margin: 20px 0;
        color: $options-text-color;
        b{
            color:$options-text-color;
        }
        svg{
            margin: 0px 14px 0px 0px;
            color: $options-text-color;
        }
    }
    .text-with-bullets-wrapper{
        display:inline-flex;
        margin-bottom: 10px;
        width:100%; 
        .bullets-wrapper{
            .bullets{
                height: 23px;
                width: 23px;
                border-radius: 8px;
                background: $bullet-background-color;
                margin: 0 auto;
                padding-inline-start: 7px;
                padding-top: 1px;
                margin: 3px 14px 0px 5px;
            }
        }
        .text-for-bullet{
            padding-top:4px;
        }
    }

    .image-wrapper{
        height: auto;
        width: 250px;
        margin: 20px auto;
    }

    .close-icon-wrapper{
        position: relative;
        bottom: 1px;
        .close-icon{
            height: 30px !important;
            width: 30px !important;
            color: $dull-text-color !important;
        }
    }

    .plain-bullets{
        height: 15px;
        width: 14px;
        border-radius: 5px;
        background: $bullet-background-color;
        margin: 0 auto;
        padding-inline-start: 7px;
        padding-top: 1px;
        margin: 3px 14px 0 5px;
        position: relative;
        top: 4px;
    }

    .bold-text{
        color:$bold-text-color;
    }

    .close-icon:hover{
    background: $close-icon-bg-on-hover;
    border-radius: 20px;
    }

    .advanced-value-note-ul{
        margin-inline-start: 25px;
        li{
            padding: 0px 8px;
            list-style-type: none;
            font-style: italic;
            b{
                font-size: 18px;
                margin: 0px 5px;
            }
        }
    }

    .advanced-value-exapples-ul{
        li{
            padding: 8px;
            // color: #bebebe;
            list-style-type:none;
            b{
                width: 110px;
                display: inline-block;
                text-align: end;
                margin-inline-end: 5px;
                float:inline-start;
            }
            span{
                float:inline-start;
            }
            div{
                width: calc(100% - 125px);
                display: inline-block;
                margin-inline-start: 5px;
                text-align: start;
            }
        }
    }
</style>



